import { TimeStampDateTimeRange } from '@modules/common/components/DateRangePicker/types';
import dayjs from 'dayjs';

export const replaceTimeStampWithDateObject = (
  date: TimeStampDateTimeRange,
) => {
  if (!date) {
    return undefined;
  }

  switch (date.type) {
    case 'absolute':
      return {
        ...date,
        startAfter:
          date.startAfter !== undefined
            ? dayjs.unix(date.startAfter / 1000).tz()
            : null,
        endBefore:
          date.endBefore !== undefined
            ? dayjs.unix(date.endBefore / 1000).tz()
            : null,
      };
    case 'since':
      return {
        ...date,
        startAfter:
          date.startAfter !== undefined
            ? dayjs.unix(date.startAfter / 1000).tz()
            : null,
      };
    default:
      return date;
  }
};
